import DragHandleIcon from '@mui/icons-material/DragHandle';
import { Box, Grid } from '@mui/material';
import { Draggable } from 'react-beautiful-dnd';
import { CostDto } from '../../common/PricePrgClient';
import { StrictModeDroppable } from '../../common/StrictModeDroppable';
import CostTypeItem from './CostTypeItem';
const grid = 8;
type Props = {
    costs: CostDto[];
    type: string;
};

const getListStyle = () => ({
    background: 'white',
    padding: grid,
    paddingLeft: '26px',
    paddingRight: '26px',
    margin: '0px 0',
    width: '100%'
});

export function CostDraggable({ costs, type }: Props) {
    return (
        <StrictModeDroppable droppableId={type} type="droppableCost">
            {providedDroppable => (
                <div ref={providedDroppable.innerRef} style={getListStyle()}>
                    {costs
                        .slice()
                        .sort((a, b) => a.order - b.order)
                        .map((item, index) => (
                            <Draggable
                                key={item.costId}
                                draggableId={'costId_' + item.costId.toString()}
                                index={index}
                            >
                                {providedDraggable => (
                                    <div
                                        ref={providedDraggable.innerRef}
                                        {...providedDraggable.draggableProps}
                                        style={{
                                            backgroundColor: index % 2 === 0 ? '#fafafa' : 'white',
                                            borderBottom: '1px solid #e2e2e2',
                                            ...providedDraggable.draggableProps.style
                                        }}
                                    >
                                        <Grid container direction="row">
                                            <Grid item>
                                                <Box
                                                    component="span"
                                                    {...providedDraggable.dragHandleProps}
                                                    sx={{ display: 'inline-block', color: 'lightgrey' }}
                                                >
                                                    <DragHandleIcon />
                                                </Box>
                                            </Grid>
                                            <CostTypeItem cost={item} />
                                        </Grid>
                                    </div>
                                )}
                            </Draggable>
                        ))}
                    {providedDroppable.placeholder}
                </div>
            )}
        </StrictModeDroppable>
    );
}
